import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** TanStack Router navigate shape for schedule-call deep links. */
export type ScheduleCallNavigateFn = (opts: {to: string}) => void;

export function navigateToScheduleCallRoute(
    navigate: ScheduleCallNavigateFn,
    scheduleHref: string,
    _workspaceId: Uuid,
    eventContainerId: Uuid,
): void {
    if (scheduleHref.trim() === "") {
        return;
    }
    const separator = scheduleHref.includes("?") ? "&" : "?";
    navigate({
        to: `${scheduleHref}${separator}eventContainerId=${eventContainerId}`,
    });
}

/** @deprecated Use `ScheduleCallNavigateFn` */
export type EmotoradScheduleNavigateFn = ScheduleCallNavigateFn;

/** @deprecated Use `navigateToScheduleCallRoute` */
export const navigateToEmotoradScheduleCallRoute = navigateToScheduleCallRoute;
